import { Canvas } from "@react-three/fiber";
import { Environment, ScrollControls } from "@react-three/drei";
import { Vector3 } from "three";
import { memberSphereCurves } from "./Paths";
import { load } from "js-yaml";
import Lights from "./Lights";
import MemberFloating from "../member/MemberFloating";
import MemberSphere from "../member/MemberSphere";
import Blobs from "../blobs/Blobs";
import Sky from "./Sky";
import { nanoid } from "nanoid";
import AutoScroll from "./AutoScroll";
import { useState, useEffect } from "react";
import { useStore } from "../store";

export default function Scene() {
  useEffect(() => {
    fetch("members.yaml")
      .then((r) => r.text())
      .then((text) => {
        return load(text);
      })
      .then((data) => {
        let roles = [...new Set(data.map((d) => d.role[0]))];
        roles = roles
          .map((x) => ({ x, r: Math.random() }))
          .sort((a, b) => a.r - b.r)
          .map((a) => a.x);

        useStore.setState({
          role1: [roles[0], Date.now()],
          role2: [roles[1], Date.now()],
          role3: [roles[2], Date.now()],
          roles: roles,
        });
      });
  }, []);

  return (
    <>
      <Canvas camera={{ position: [-0.1, 0, 20], fov: 60 }}>
        <Lights />
        <ScrollControls pages={8}>
          <AutoScroll />
          {/* 상단 */}
          <Blobs />

          {/* 중반 */}
          <MemberSphere
            key={nanoid()}
            idx={0}
            curve={memberSphereCurves[0]}
            radius={4}
            store={"role1"}
          />

          <MemberSphere
            key={nanoid()}
            idx={1}
            curve={memberSphereCurves[1]}
            radius={4}
            store={"role2"}
          />
          <MemberSphere
            key={nanoid()}
            idx={2}
            curve={memberSphereCurves[2]}
            radius={4}
            store={"role3"}
          />

          {/* 하단 */}
          <MemberFloating center={new Vector3(0, 0, 4)} />
          <Sky color="#fcd7e4" />
          <Environment files="adamsbridge.hdr" />
        </ScrollControls>

        <fog attach="fog" args={["#d7dbe3", 0, 50]} />
      </Canvas>
    </>
  );
}
